module.exports = __webpack_public_path__ + "img/soundcomm.2531dca4.png";